import React, { useEffect, useRef, useState } from "react"
import _ from "lodash"

import { CalcData } from 'data/calc'
import calcService from 'data/calc'
import rentRollService, { RentRoll } from "data/rent-roll"

import { rowContextService } from "components/table/table-automation"
import { RentRollReport_s } from "components/rent-roll/rent-roll/rent-roll-styles"
import { TenantCashFlow } from "components/reporting/tcf-grid"

const RentRollReport = (props: {data: RentRoll[]}) => {
  const [current, setCurrent] = useState<number | null>(null)
  const [calcData, setCalcData] = useState<CalcData | null>(null);

  useEffect(() => {
    const rowContextSubscription = rowContextService.stream().subscribe(context => {
      setCurrent(context)
    })


    const calcSubscription = calcService.stream().subscribe(data => {
      if(data.state=='ok')
        setCalcData(data.value as CalcData)
    })


    return function cleanup() {
      rowContextSubscription.unsubscribe()
      calcSubscription.unsubscribe()
    }
  }, [props.data])

  const tenantData = calcData?.tenants.filter(t => t.rentrollid == current) || []
  return (
    <RentRollReport_s>
      {calcData && tenantData?.length && <TenantCashFlow
        dataBeginDate={calcData.analysisPeriodInterval.begin}
        dataEndDate={calcData.analysisPeriodInterval.end}
        data={_.first(tenantData)}
      />}
      {!calcData && null}
      {calcData && (tenantData?.length ? false : true) && <div>This tenant has no lease activity within the analysis</div>}
    </RentRollReport_s>
  )
}

export default RentRollReport
